export const centsBetween = (aHz: number, bHz: number) => 1200 * Math.log2(aHz / bHz);

export const isSamePitchHz = (aHz: number, bHz: number, maxCents = 45) => {
  if (!Number.isFinite(aHz) || !Number.isFinite(bHz) || aHz <= 0 || bHz <= 0) return false;
  return Math.abs(centsBetween(aHz, bHz)) <= maxCents;
};

export const isApproxHarmonic = (
  higherHz: number,
  baseHz: number,
  maxMultiple = 12,
  maxCents = 45,
) => {
  if (
    !Number.isFinite(higherHz) ||
    !Number.isFinite(baseHz) ||
    higherHz <= 0 ||
    baseHz <= 0 ||
    higherHz <= baseHz
  ) {
    return false;
  }

  const ratio = higherHz / baseHz;
  const nearest = Math.round(ratio);
  if (nearest < 2 || nearest > maxMultiple) return false;
  return Math.abs(1200 * Math.log2(ratio / nearest)) <= maxCents;
};

export const harmonicNumberFor = (higherHz: number, baseHz: number, maxCents = 45) => {
  if (!Number.isFinite(higherHz) || !Number.isFinite(baseHz) || higherHz <= 0 || baseHz <= 0) {
    return null;
  }
  const ratio = higherHz / baseHz;
  const nearest = Math.round(ratio);
  if (nearest < 1) return null;
  const expectedHz = baseHz * nearest;
  return Math.abs(centsBetween(higherHz, expectedHz)) <= maxCents ? nearest : null;
};
